import type React from 'react';

interface DepositsIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function DepositsIcon({ size = 24, ...props }: DepositsIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_17078_21783)">
        <path
          d="M6.577 10.4705H4.80328C5.21114 10.8404 5.66643 11.1439 6.17862 11.3526C6.77618 11.5992 7.4022 11.7225 8.0377 11.7225C8.6732 11.7225 9.29922 11.5992 9.89678 11.3526C10.409 11.1439 10.8548 10.8309 11.2626 10.4705H9.49841C8.56887 10.8499 7.50654 10.8499 6.577 10.4705Z"
          fill="currentColor"
        />
        <path
          d="M7.55432 9.77807C7.55432 10.0437 7.77248 10.2618 8.03806 10.2618C8.30364 10.2618 8.5218 10.0437 8.5218 9.77807V9.52197H7.55432V9.77807Z"
          fill="currentColor"
        />
        <path
          d="M10.7978 9.61654C10.4374 9.97698 10.0106 10.2615 9.53633 10.4607C9.53633 10.4607 9.51736 10.4607 9.50787 10.4607H11.2721C11.3385 10.4038 11.4144 10.3564 11.4808 10.29C11.7179 10.0529 11.9266 9.78727 12.1068 9.51221H10.8737C10.8737 9.51221 10.8263 9.5786 10.7978 9.60706V9.61654Z"
          fill="currentColor"
        />
        <path
          d="M4.80317 10.47H6.57688C6.57688 10.47 6.55791 10.47 6.54843 10.47C6.07417 10.2708 5.64734 9.98629 5.28691 9.62586C5.25845 9.5974 5.23948 9.55946 5.21103 9.53101H3.97797C4.15818 9.80607 4.36686 10.0717 4.60398 10.3088C4.67038 10.3752 4.74626 10.4226 4.81265 10.4795L4.80317 10.47Z"
          fill="currentColor"
        />
        <path
          d="M6.32098 8.004H6.82369C6.66245 7.90915 6.47275 7.90915 6.32098 8.004Z"
          fill="currentColor"
        />
        <path
          d="M9.31824 9.14209H6.75726C6.98491 9.30334 7.25997 9.42664 7.55401 9.48355V9.52149H8.52149V9.48355C8.81553 9.42664 9.0906 9.30334 9.31824 9.14209Z"
          fill="currentColor"
        />
        <path
          d="M8.5216 7.42497C8.60697 7.45343 8.69233 7.50086 8.75873 7.54828L8.7777 7.56725C8.92946 7.68107 9.01483 7.81386 9.01483 7.95614C9.01483 7.97511 9.00534 7.9846 9.00534 8.00357H9.98231C9.98231 8.00357 9.98231 7.97511 9.98231 7.95614C9.98231 7.51034 9.75466 7.093 9.36577 6.79896C9.12865 6.61874 8.8441 6.49544 8.53109 6.42904V5.26237C8.59748 5.29083 8.66388 5.32877 8.72079 5.37619L8.91998 5.53744C9.02431 5.61332 9.14762 5.66075 9.28041 5.64178C9.40372 5.63229 9.52702 5.5659 9.6029 5.46156C9.67878 5.35722 9.71672 5.23392 9.70724 5.10113C9.68827 4.96834 9.63136 4.85451 9.52702 4.77863L9.32783 4.61739C9.10019 4.43717 8.83461 4.31386 8.54057 4.24747V3.94394C8.54057 3.67836 8.32241 3.46021 8.05683 3.46021C7.79125 3.46021 7.57309 3.67836 7.57309 3.94394V4.24747C7.27905 4.31386 7.00399 4.44666 6.78583 4.61739C6.41591 4.91142 6.19775 5.33825 6.19775 5.76508C6.19775 6.19191 6.41591 6.61874 6.78583 6.91278C7.01347 7.093 7.27905 7.2163 7.57309 7.2827V7.99408H8.54057V7.42497H8.5216ZM7.55412 6.27728C7.48773 6.24882 7.42133 6.21088 7.36442 6.16346C7.22214 6.04964 7.14626 5.90736 7.14626 5.76508C7.14626 5.62281 7.22214 5.48053 7.36442 5.36671C7.42133 5.31928 7.48773 5.28134 7.55412 5.25289V6.27728Z"
          fill="currentColor"
        />
        <path
          d="M4.3383 8.00386C4.22448 7.63394 4.1486 7.25453 4.1486 6.86565C4.1486 5.82229 4.55645 4.84532 5.28681 4.11497C6.02664 3.37513 7.00361 2.97676 8.03748 2.97676C9.07136 2.97676 10.0578 3.38462 10.7882 4.11497C11.528 4.85481 11.9264 5.83177 11.9264 6.86565C11.9264 7.25453 11.8505 7.63394 11.7367 8.00386H12.3153C12.4575 8.00386 12.5903 8.02283 12.7231 8.05128C12.818 7.66239 12.8844 7.2735 12.8844 6.86565C12.8844 5.58516 12.3627 4.33313 11.4616 3.43204C10.5415 2.51199 9.32746 2.00928 8.028 2.00928C6.72854 2.00928 5.50496 2.51199 4.5944 3.43204C3.69331 4.33313 3.17163 5.59464 3.17163 6.86565C3.17163 7.26402 3.23803 7.65291 3.33288 8.0418C3.4467 8.02283 3.55103 8.00386 3.66486 8.00386H4.32881H4.3383Z"
          fill="currentColor"
        />
        <path
          d="M10.8739 9.52149H12.1069C12.1828 9.39819 12.2397 9.2654 12.3061 9.14209H11.1679C11.0731 9.27488 10.9782 9.40767 10.8644 9.52149H10.8739Z"
          fill="currentColor"
        />
        <path
          d="M5.21078 9.52149C5.09696 9.40767 5.00211 9.27488 4.90725 9.14209H3.76904C3.83544 9.2654 3.89235 9.39819 3.96823 9.52149H5.20129H5.21078Z"
          fill="currentColor"
        />
        <path
          d="M12.7328 8.04196C12.6759 8.2696 12.619 8.49724 12.5241 8.7154C12.4672 8.86716 12.3723 8.99047 12.2965 9.13274H12.3154C13.1976 9.13274 13.9089 9.88206 13.9089 10.8116C13.9089 11.7411 13.1976 12.4905 12.3154 12.4905H3.67452C2.7924 12.4905 2.08102 11.7411 2.08102 10.8116C2.08102 9.88206 2.7924 9.13274 3.67452 9.13274H3.76937C3.69349 8.99047 3.60812 8.85767 3.54172 8.7154C3.44687 8.49724 3.38996 8.26011 3.33305 8.03247C2.01462 8.2032 0.990234 9.37935 0.990234 10.8116C0.990234 12.3672 2.19484 13.6287 3.66503 13.6287H12.3154C13.7856 13.6287 14.9902 12.3672 14.9902 10.8116C14.9902 9.40781 14.0038 8.25063 12.7233 8.04196H12.7328Z"
          fill="currentColor"
        />
        <path
          d="M9.36564 9.11342C9.74504 8.82887 9.9632 8.42101 9.98217 8.00366H9.0052C8.98623 8.12697 8.91984 8.24079 8.78705 8.34513C8.71117 8.40204 8.6258 8.44946 8.53095 8.4874V8.00366H7.56347V8.4874C7.46862 8.44946 7.38325 8.40204 7.30737 8.34513L6.88054 8.02263C6.88054 8.02263 6.85209 8.01315 6.8426 8.00366H6.33989C6.29247 8.03212 6.24504 8.07006 6.2071 8.11748C6.04585 8.32616 6.09328 8.62968 6.30195 8.79092L6.72878 9.11342C6.72878 9.11342 6.75724 9.13239 6.76672 9.13239H9.3277C9.3277 9.13239 9.35615 9.1229 9.36564 9.11342Z"
          fill="currentColor"
        />
        <path
          d="M11.7465 8.00366C11.7086 8.11748 11.6896 8.24079 11.6422 8.35461C11.5284 8.63916 11.3576 8.89526 11.1774 9.14187H12.3156C12.3915 8.9996 12.4769 8.86681 12.5433 8.72453C12.6381 8.50637 12.695 8.27873 12.752 8.05109C12.6192 8.03212 12.4769 8.00366 12.3441 8.00366H11.7655H11.7465Z"
          fill="currentColor"
        />
        <path
          d="M3.76979 9.14187H4.908C4.72778 8.89526 4.56653 8.63916 4.44323 8.35461C4.3958 8.24079 4.37683 8.11748 4.33889 8.00366H3.67493C3.56111 8.00366 3.44729 8.02263 3.34296 8.0416C3.39987 8.26924 3.45678 8.50637 3.55163 8.72453C3.60854 8.87629 3.70339 8.9996 3.77927 9.14187H3.76979Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17078_21783">
          <rect width="14" height="11.6287" fill="white" transform="translate(1 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}
